/* Styling and images */
import logo from '../../assets/img/moto4rent-black-4.png';
import './Header.scss';

/* Dependencies */
import { useTranslation } from 'react-i18next';
import { NavLink, useLoaderData } from 'react-router-dom';
import { MotorcycleModel } from '../../model/moto.model';

export default function Header() {
    const motorcycles = useLoaderData() as MotorcycleModel[];
    const { t, i18n: { language: lang } } = useTranslation();
    
    /* Build list of motorcycles dynamically */
    const motorcycleInfos = motorcycles.map(x => ({
        route: x.name.split(' ').join('-').toLowerCase(),
        name: x.name,
    }));
    const motorcycleItems = motorcycleInfos
        .map(x => <li key={x.route}><NavLink to={`/${lang}/${t('routes:rent-moto')}/${x.route}`}>{x.name}</NavLink></li>);

    return (
        <header className="header fixed">
            <div className="header-wrapper">
                <div className="container">
                    {/* Logo */}
                    <div className="logo">
                        <NavLink to={'/'}><img src={logo} alt="Moto4Rent" className="img-rounded"/></NavLink>
                    </div>
     
                    {/* /Logo */}
                    {/* Mobile menu toggle button */}
                    <a href="#" className="menu-toggle btn ripple-effect btn-theme-transparent"><i className="fa fa-bars"></i></a>
                    {/* /Mobile menu toggle button */}
    
                    {/* Navigation */}
                    <nav className="navigation closed clearfix">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                {/* navigation menu */}
                                <a href="#" className="menu-toggle-close btn"><i className="fa fa-times"></i></a>
                                <ul className="nav sf-menu">
                                    <li nav-item="true">
                                        <NavLink to={'/'}>
                                            {t('common:header.home')}
                                        </NavLink>
                                    </li>
                                    <li nav-item="true">
                                        <NavLink to={`/${lang}/${t('routes:about-us')}`}>
                                            {t('common:header.about-us')}
                                        </NavLink>
                                    </li>
                                    <li nav-item="true">
                                        <NavLink to={`/${lang}/${t('routes:rent-moto')}`}>
                                            {t('common:header.motorcycles')}
                                        </NavLink>
                                        <ul>
                                            {motorcycleItems}
                                        </ul>
                                    </li>
                                    <li nav-item="true">
                                        <NavLink to={`/${lang}/${t('routes:partners')}`}>
                                            {t("common:header.partners")}
                                        </NavLink>
                                    </li>
                                    <li nav-item="true">
                                        <NavLink to={`/${lang}/${t('routes:contact')}`}>
                                            {t('common:header.contact')}
                                        </NavLink>
                                    </li>
                                    <li>
                                        <ul className="social-icons">
                                            <li><a href="https://www.facebook.com/moto4rent.ro" target="_blank" className="facebook"><i className="fa fa-facebook"></i></a></li>
                                            <li><a href="https://www.instagram.com/moto4rent.ro/" target="_blank" className="twitter"><i className="fa fa-instagram"></i></a></li>
                                            <li><a href="https://www.youtube.com/@moto4rent-ro123" target="_blank" className="instagram"><i className="fa fa-youtube"></i></a></li>
                                            <li><a href="https://www.tiktok.com/@moto4rent" target="_blank" className="pinterest"><i className="fa fa-tumblr"></i></a></li>
                                            <li><a href="https://play.google.com/store/apps/details?id=com.moto4rent.renting_app&hl=ro&gl=US" target="_blank" className="google"><i className="fa fa fa-play"></i></a></li>
                                        </ul>
                                    </li>
                                </ul>
                                {/* /navigation menu */}
                            </div>
                        </div>
                        
                        {/* Add Scroll Bar */}
                        <div className="swiper-scrollbar"></div>
                    </nav>
                    {/* /Navigation */}
                </div>
            </div>
        </header>
    )
}